import React from 'react';
import commonResource from '../../locales/th/common.json';
import Icon404 from './assets/404.png';
import { ErrorWrapper } from './Error.style.js';
import { generateHomePageUrl } from '../../common/helpers/routing/landingPageUrlGenerator';

interface ErrorContentProps {
  title?: string;
  subtitle?: string;
  description?: string;
}
const ErrorContent: React.FC<ErrorContentProps> = ({
  title,
  subtitle,
  description,
}) => {
  const errorButtonText = commonResource.errorButton;

  return (
    <ErrorWrapper data-test={'error'}>
      <div className="error-icon">
        <img src={Icon404} alt={'404'} />
      </div>
      <div className="error-info">
        <p className="title">{title}</p>
        <p className="sub-title">{subtitle}</p>
        <p className="description">{description}</p>
        <a href={generateHomePageUrl()}>
          <button>{errorButtonText}</button>
        </a>
      </div>
    </ErrorWrapper>
  );
};

export default ErrorContent;
